import { TApplicationState } from '../../types/redux';

export function getIsAuthenticated(state: TApplicationState) {
  return Boolean(state.user);
}
